import Vue from 'vue';
import producerTransformer from './../../transformers/producer';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(producerTransformer.fetch(errors));
};

export default clientGroup => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('producers', clientGroup)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/producer/store.js